import { render, staticRenderFns } from "./truckOrder.vue?vue&type=template&id=7fe4bf90&scoped=true&"
import script from "./truckOrder.vue?vue&type=script&lang=js&"
export * from "./truckOrder.vue?vue&type=script&lang=js&"
import style0 from "./truckOrder.vue?vue&type=style&index=0&id=7fe4bf90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe4bf90",
  null
  
)

export default component.exports